import { useState, useEffect } from 'react'
import './formationWindow.scss'
import { normalizeFormationName } from './utils'

export default function FormationWindow({ formationName }) {
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!formationName) {
      setLoading(false)
      return
    }

    const normalized = normalizeFormationName(formationName)
    const filePath = `/datas/formations/${normalized}.json`

    fetch(filePath)
      .then((res) => {
        if (!res.ok) throw new Error(`Erreur ${res.status}`)
        return res.json()
      })
      .then((data) => {
        setContent(data)
        setLoading(false)
      })
      .catch(() => {
        setContent(null)
        setLoading(false)
      })
  }, [formationName])

  if (loading) {
    return <span>{formationName || 'Formation inconnue'}</span>
  }

  if (!content || !Array.isArray(content) || content.length === 0) {
    return <span className="formation-name">Formation : {formationName || 'inconnue'}</span>
  }

  return (
    <div className="formation-accordion">
      <span className="formation-name">Formation : {formationName}</span>

      <button
        type="button"
        className={`accordion-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '▲' : '▼'}
      </button>

      {isOpen && (
        <div className="accordion-content">
          {content.map((source, index) => (
            <div key={index} className="source">
              {Object.entries(source).map(([key, value]) => {
                if (key === 'titre') {
                  return <h3 key={key}>{value}</h3>
                }
                if (key.startsWith('sousTitre')) {
                  return <h4 key={key} className="mt-2">{value}</h4>
                }
                if (key.startsWith('paragraphe')) {
                  return <p key={key}>{value}</p>
                }
                return null // ignore les autres clés si y en a
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}